import type { IssueLabels } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/issue-labels/types';
import type { State } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/types';

// eslint-disable-next-line jira/export/no-external-exports
export type { IssueLabels } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/state/domain/issue-labels/types';

export const getIssueLabels = (state: State): IssueLabels => state.domain.issueLabels;
